module.exports = __webpack_public_path__ + "/images/ico-color-q.ff0dc9c.svg";